import { useEffect } from 'react'
import Box from '@mui/material/Box'
import HelmetMeta from '../../layouts/HelmetMeta.js'
import { Link } from 'react-router-dom'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

export default function NotFound () {
  const { t } = useTranslation('legals')

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Box sx={{ textAlign: 'center', pt: 10 }}>
      <HelmetMeta is404 />
      <Typography variant='h1' sx={{ mb: 2 }}>
        404
      </Typography>
      <Typography variant='h4' sx={{ mb: 2 }}>
        {t('notFound.oops')}
      </Typography>

      <Typography variant='body1' sx={{ mb: 4 }}>
        {t('notFound.description')}
      </Typography>
      <Button component={Link} to='/' variant='contained'>
        {t('notFound.goHome')}
      </Button>
    </Box>
  )
}
